import script from "./PaymentMethods.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethods.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethods.vue?vue&type=style&index=0&id=3f078f02&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f078f02"]])

export default __exports__